import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Shield, ArrowRight } from 'lucide-react';
function getCheckoutUrl() {
  const base = 'https://pay.hotmart.com/Y104649799O?hideBillet=1&offDiscount=80OFF';
  const params = new URLSearchParams(window.location.search);
  const src = params.get('src');
  return src ? `${base}&src=${encodeURIComponent(src)}` : base;
}
export function OfferSection() {
  const checkoutUrl = getCheckoutUrl();
  const handleCheckoutClick = (e: React.MouseEvent) => {
    e.preventDefault();
    // Fire Facebook AddToCart event
    const fbq = (window as any).fbq;
    if (fbq) {
      fbq('track', 'AddToCart', {
        content_name: 'Método Caja De Oro',
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    }
    // Small delay to ensure pixel fires before redirect
    setTimeout(() => {
      window.open(checkoutUrl, '_blank', 'noopener,noreferrer');
    }, 300);
  };
  return <section id="offer" className="w-full bg-slate-900 py-16 md:py-24 relative overflow-hidden" data-id="element-109">
      {/* Background glow */}
      <div className="absolute inset-0 bg-amber-500/5 pointer-events-none" data-id="element-110"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-slate-800 rounded-3xl p-8 md:p-16 text-center border-2 border-amber-500 shadow-[0_0_50px_rgba(245,158,11,0.2)]" data-id="element-112">
          <h2 className="text-2xl md:text-3xl text-slate-300 mb-6" data-id="element-113">
            Hoy puedes obtener el acceso completo al <br data-id="element-114" />
            <span className="font-bold text-white" data-id="element-115">
              Método "Caja de Oro"
            </span>{' '}
            por un pago único de solo
          </h2>

          <div className="flex flex-col items-center justify-center gap-2 mb-8" data-id="element-116">
            <span className="text-2xl text-slate-500 line-through font-bold" data-id="element-117">
              $31.95
            </span>
            <span className="text-6xl md:text-8xl font-black text-gold-gradient tracking-tight" data-id="element-118">
              $6.39 <span className="text-4xl text-amber-500" data-id="element-119">USD</span>
            </span>
          </div>

          <p className="text-slate-400 mb-10 max-w-lg mx-auto" data-id="element-120">
            Es menos de lo que cuesta una comida rápida, pero con el potencial
            de llenar tu refrigerador cada semana.
          </p>

          <motion.a href={checkoutUrl} onClick={handleCheckoutClick} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} animate={{
          boxShadow: ['0 0 0 0 rgba(245, 158, 11, 0.4)', '0 0 0 20px rgba(245, 158, 11, 0)']
        }} transition={{
          boxShadow: {
            duration: 1.5,
            repeat: Infinity
          }
        }} className="w-full md:w-auto bg-gold-gradient text-slate-900 font-bold text-xl py-5 px-10 rounded-full shadow-xl flex items-center justify-center gap-3 mx-auto mb-8 no-underline cursor-pointer" data-id="element-121">
            ¡QUIERO EMPEZAR MI CAJA DE ORO AHORA!
            <ArrowRight className="w-6 h-6" data-id="element-122" />
          </motion.a>

          <div className="flex items-center justify-center gap-2 text-slate-400 text-sm md:text-base" data-id="element-123">
            <Shield className="w-5 h-5 text-green-500" data-id="element-124" />
            <span data-id="element-125">Acceso inmediato tras el pago. Seguro y garantizado.</span>
          </div>
        </motion.div>
      </div>
    </section>;
}